import { Grid } from '@mui/material';
import { NotificationScreen } from '@tassat/layout';
import React from 'react';

import { useClientLogos } from 'SharedComponents/hooks/useClientLogos';
import { useClientThemeData } from 'SharedComponents/hooks/useClientThemeData';

import type { SSOLogoutProps } from '.';

export const SSOLogout = (props: SSOLogoutProps) => {
    const { classes } = props;

    const clientInfo = useClientThemeData();
    const clientLogoUrls = useClientLogos();

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
        >
            <NotificationScreen
                clientLogoUrl={clientLogoUrls.ApplicationLogoUrl}
                headerLogoHeight={65}
                messages={[
                    'You have signed out of your session.',
                    'Please close your browser window.',
                    'Please contact us for assistance at any time, 24 hours a day, 7 days a week.'
                ]}
                subtitle='Your Gateway to the Future of Digital Financial Services'
                supportEmail={clientInfo.support.contactInfo.email || '#'}
                supportPhone={clientInfo.support.contactInfo.phoneDirect ||
                    clientInfo.support.contactInfo.phoneTollFree ||
                    'Call support line'}
                title='Signed Out'
                type='prop'
            />
        </Grid>
    );
};